import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import DatePicker from "../../../../../helpers/ui/DatePicker";

import SweetAlert from "react-bootstrap-sweetalert";
import {
  Label,
  Row,
  Col,
  Button,
  Tooltip,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import Select from "../../../../../helpers/ui/CustomSelect";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import { AvForm, AvField } from "availity-reactstrap-validation";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import LoadingComponent from "./LoadingComponent";
var reformatOptionEselonFungsional = function (option) {
  var grouped = groupBy(option, (pet) => pet.echelon_fungsional_categori);
  var listopsigroup = Array.from(grouped);

  return listopsigroup.map(function (opsi) {
    var newObj = {};

    newObj["label"] = opsi[0];
    newObj["options"] = opsi[1].map(function (options) {
      var newOpsi = {};
      newOpsi["value"] = options.echelon_uuid;
      newOpsi["label"] = options.echelon_name_full;

      return newOpsi;
    });

    return newObj;
  });
};
function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}
class TableActiveComponent extends Component {
  dataTableBloc = new IndexBloc();
  indexBloc = new IndexBloc();

  source;
  historyTable = "historyPositionTableActive"; // Nama di tiap tabel harus beda karena akan disimpan di session
  defaultOrder = "position_id"; // orderBy
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      chartUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      loadingDetail: true,
      detail: null,
      workUnit: null,
      eselon: null,
      eselon_struktural: [],
      eselon_fungsional: [],
      show_is_digunakan: false,
      list_digunakan: "",
      filter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: this.defaultOrder,
          order: this.defaultSort,
        },
      },
      echelon_is_pns: 1,
    };
  }

  toggleModal = () => this.setState({ updateUuid: null, detailUuid: null });
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.updateUuid,
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    await this.indexBloc.fetchUpdate(this.state.dataForm);
  };

  inactiveData = async () => {
    console.log("dataform");
    console.log(this.state.dataForm);

    await this.indexBloc.fetchDelete(this.state.dataForm);
  };
  checkDelete = async (position_uuid, is_digunakan, list_digunakan) => {
    //console.log(position_uuid + ', digunakan: ' + is_digunakan + ', list_digunakan : ' + list_digunakan)
    //console.log(position_uuid)

    if (is_digunakan == 0) {
      this.setState({
        show_is_digunakan: false,
        inactiveUuid: position_uuid,
        dataForm: {
          uuid: position_uuid,
        },
        confirm: true,
      });
      //console.log(this.state.inactiveUuid)
    } else {
      this.setState({
        show: true,
        show_is_digunakan: true,
        list_digunakan: list_digunakan.replace(/\|/g, "\r\n"),
      });
    }
    //await this.indexBloc.fetchDelete({ uuid: position_uuid }, this.source.token)
  };
  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        if (this.state.updateUuid !== null) {
          this.submitData();
        } else if (this.state.inactiveUuid !== null) {
          this.inactiveData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props.currentPeriod
        ? this.props.currentPeriod.position_period_uuid
        : null,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  loadDetail = async (uuid) => {
    await this.indexBloc.fetchDetail({ uuid: uuid }, this.source.token);
  };

  loadEselon = async (uuid, position_is_pns) => {
    await this.indexBloc.fetchEselon({
      uuid: uuid,
      echelon_is_pns: position_is_pns,
    });
  };

  loadWorkUnit = async () => {
    await this.indexBloc.fetchWorkUnit({}, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
    this.loadWorkUnit();
  };

  hideAlert() {
    this.setState({
      show: false,
    });
  }

  onChangeCategorySelected = (type) => {
    this.setState((prevState) => ({
      detail: {
        ...prevState.detail,
        position_is_pns: type.value,
        position_echelon_uuid: null,
      },
    }));
    this.indexBloc.fetchEselon({
      echelon_is_pns: type.value,
    });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.eselonChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            eselon: result.data.response.eselon_struktural,
            eselon_struktural: result.data.response.eselon_struktural,
            eselon_fungsional: result.data.response.eselon_fungsional,
          });
          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            workUnit: result.data.response.result,
          });
          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            loadingDetail: false,
            detail: response,
            is_struktural: response.position_type,
          });
          this.loadEselon(
            response.position_uuid,
            this.state.detail.position_is_pns
          );
          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status === true) {
            this.setState({
              loading: false,
              success: true,
            });
            this.toggleModal();
            this.props.handleInactiveSuccess();
            this.props.loadDraft();
          } else {
            console.log("ada");
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
            this.toggleModal();
            this.props.handleInactiveSuccess();
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          this.toggleModal();
          this.props.handleInactiveSuccess();
          break;
        default:
          break;
      }
    });
    this.indexBloc.deleteChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.toggleModal();
          this.props.handleInactiveSuccess();
          this.props.loadDraft();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          this.toggleModal();
          this.props.handleInactiveSuccess();
          break;
        default:
          break;
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentPeriod !== this.props.currentPeriod) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.indexBloc.detailChannel?.unsubscribe();
    this.indexBloc.eselonChannel?.unsubscribe();
    this.indexBloc.workUnitChannel?.unsubscribe();
    this.indexBloc.updateChannel?.unsubscribe();
  }

  columns = [
    {
      key: "position_name",
      text: "Nama Jabatan",
      sortable: true,
    },
    {
      key: "position_name_kemenkeu",
      text: "Nama Jabatan Kemenkeu",
      sortable: true,
    },
    {
      key: "position_is_pns",
      text: "Kategori",
      sortable: true,
      cell: (record) => {
        var kategori = record.position_is_pns;
        return (
          <span>
            {kategori === 1 ? (
              <label className="badge rounded-pill bg-soft-primary font-size-12">
                PNS
              </label>
            ) : (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                PPPK
              </label>
            )}
          </span>
        );
      },
    },
    {
      key: "position_work_unit_name",
      text: "Unit Kerja",
      sortable: true,
    },
    {
      key: "position_type_name",
      text: "Jenis Jabatan",
      sortable: true,
    },
    {
      key: "position_type_kemenkeu",
      text: "Jenis Jabatan Kemenkeu",
      sortable: true,
    },

    {
      key: "echelon_name_full",
      text: "Eselon/Jenjang",
      sortable: true,
    },
    {
      key: "position_bup",
      text: "BUP",
      sortable: true,
    },
    {
      key: "position_grade",
      text: "Grade", // text: "Grade / Golongan",
      sortable: true,
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.position_id;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.position_uuid,
                  });
                  this.loadDetail(record.position_uuid);
                }}
                style={{ marginRight: "2px", padding: "2px 5px" }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{ marginBottom: "2px" }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detail
              </Tooltip>
            </span>
            {accessRole("update") && (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.position_uuid,
                    });
                    this.loadDetail(record.position_uuid);
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-pen"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Perbaharui
                </Tooltip>
              </span>
            )}
            {accessRole("delete") ? (
              <span>
                <button
                  className="btn btn-danger btn-sm"
                  id={"delete-" + thisId}
                  onClick={() => {
                    this.checkDelete(
                      record.position_uuid,
                      record.is_digunakan,
                      record.list_digunakan
                    );
                  }}
                  style={{
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-trash-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["delete" + thisId]}
                  target={"delete-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["delete" + thisId]: !this.state["delete" + thisId],
                    });
                  }}
                >
                  Nonaktifkan
                </Tooltip>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <Fragment>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />

        <Modal
          size="lg"
          isOpen={
            this.state.updateUuid !== null
              ? true
              : this.state.detailUuid !== null
              ? true
              : false
          }
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            {this.state.detailUuid != null ? "Detail" : "Edit"} Jabatan
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
          >
            <ModalBody>
              {this.state.loadingDetail == true ? (
                <Fragment>
                  <LoadingComponent message="Memeriksa Data Jabatan..." />
                </Fragment>
              ) : (
                <Fragment>
                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Kategori Pegawai <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <Select
                        name="position_is_pns"
                        errorMessage="Pilih Kategori Pegawai"
                        options={[
                          { value: "0", label: "PPPK" },
                          { value: "1", label: "PNS" },
                        ]}
                        defaultValue={this.state.detail.position_is_pns}
                        placeholder="Pilih Kategori Pegawai"
                        validate={{ required: { value: true } }}
                        onChange={this.onChangeCategorySelected}
                        isDisabled={
                          this.state.detailUuid != null ? true : false
                        }
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Nama Jabatan <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <AvField
                        name="position_name"
                        placeholder="Nama Jabatan"
                        errorMessage="Masukkan Nama Jabatan"
                        type="text"
                        className="form-control"
                        value={this.state.detail.position_name}
                        disabled={this.state.detailUuid != null ? true : false}
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Unit Kerja
                    </Label>
                    <Col md="8">
                      {this.state.detailUuid != null ? (
                        <AvField
                          name="position_work_unit_uuid"
                          errorMessage="Masukkan Unit Kerja"
                          type="text"
                          className="form-control"
                          value={this.state.detail.work_unit_name}
                          disabled={
                            this.state.detailUuid != null ? true : false
                          }
                          validate={{ required: { value: true } }}
                        />
                      ) : (
                        <Select
                          name="position_work_unit_uuid"
                          errorMessage="Pilih Unit Kerja"
                          options={this.state.workUnit}
                          optionLabel="work_unit_name"
                          optionValue="work_unit_uuid"
                          defaultValue={
                            this.state.detail.position_work_unit_uuid
                          }
                          placeholder="Pilih Unit Kerja"
                          onInputChange={this.handleSelectInputChange}
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Jenis Jabatan <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <Select
                        name="position_type"
                        errorMessage="Pilih Jenis Jabatan"
                        options={
                          this.state.detail.position_is_pns == 0
                            ? [
                                { value: "2", label: "Fungsional Umum" },
                                { value: "3", label: "Fungsional Tertentu" },
                              ]
                            : [
                                { value: "1", label: "Struktural" },
                                { value: "2", label: "Fungsional Umum" },
                                { value: "3", label: "Fungsional Tertentu" },
                              ]
                        }
                        defaultValue={this.state.detail.position_type}
                        isDisabled={
                          this.state.detailUuid != null ? true : false
                        }
                        onChange={(v) =>
                          this.setState((prevState) => ({
                            detail: {
                              ...prevState.detail,
                              position_type: v.value,
                            },
                            is_struktural: v.value,
                          }))
                        }
                        placeholder="Pilih Jenis Jabatan"
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>
                  {/* <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Jenis Jabatan <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">

                                            {this.state.detailUuid != null ?
                                                <AvField
                                                    name="position_type"
                                                    placeholder="Nama Struktur Organisasi"
                                                    errorMessage="Masukkan Struktur Organisasi"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.detail.type_name}
                                                    disabled={this.state.detailUuid != null ? true : false}
                                                    validate={{ required: { value: true } }}
                                                />
                                                :
                                                <Select
                                                    name="position_type"
                                                    errorMessage="Pilih Jenis Jabatan"
                                                    options={
                                                        [{ value: '1', label: 'Struktural' }, { value: '2', label: 'Fungsional' },]
                                                    }
                                                    defaultValue={this.state.detail.position_type}
                                                    placeholder="Pilih Eselon"
                                                    validate={{ required: { value: true } }}
                                                />
                                            }
                                        </Col>
                                    </Row> */}
                  {this.state.is_struktural == 1 ? (
                    <Row className="mb-3">
                      <Label className="col-md-4 col-form-label">
                        Eselon/Jenjang
                      </Label>
                      <Col md="8">
                        <Select
                          name="position_echelon_uuid"
                          errorMessage="Pilih Eselon/Jenjang"
                          options={this.state.eselon_struktural}
                          placeholder="Pilih Eselon/Jenjang"
                          optionLabel="echelon_name_full"
                          optionValue="echelon_uuid"
                          value={this.state.detail.position_echelon_uuid}
                          defaultValue={this.state.detail.position_echelon_uuid}
                          isDisabled={
                            this.state.detailUuid != null ? true : false
                          }
                          // validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {this.state.is_struktural == 3 ? (
                    <Row className="mb-3">
                      <Label className="col-md-4 col-form-label">
                        Eselon/Jenjang
                      </Label>
                      <Col md="8">
                        <Select
                          name="position_echelon_uuid"
                          errorMessage="Pilih Eselon/Jenjang"
                          options={this.state.eselon_fungsional}
                          optionLabel="echelon_name_full"
                          optionValue="echelon_uuid"
                          value={this.state.detail.position_echelon_uuid}
                          defaultValue={this.state.detail.position_echelon_uuid}
                          isDisabled={
                            this.state.detailUuid != null ? true : false
                          }
                          placeholder="Pilih Eselon/Jenjang"
                          // validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {/* <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Eselon <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">

                                            {this.state.detailUuid != null ?
                                                <AvField
                                                    name="position_echelon_uuid"
                                                    placeholder="Nama Struktur Organisasi"
                                                    errorMessage="Masukkan Struktur Organisasi"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.detail.echelon_name}
                                                    disabled={this.state.detailUuid != null ? true : false}
                                                    validate={{ required: { value: true } }}
                                                />
                                                :
                                                <Select
                                                    name="position_echelon_uuid"
                                                    errorMessage="Pilih Eselon"
                                                    options={this.state.eselon}
                                                    optionLabel="echelon_name"
                                                    defaultValue={this.state.detail.position_echelon_uuid}
                                                    optionValue="echelon_uuid"
                                                    placeholder="Pilih Eselon"
                                                    validate={{ required: { value: true } }}
                                                />
                                            }
                                        </Col>
                                    </Row> */}

                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Batas Usia Pensiun <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <AvField
                        name="position_bup"
                        placeholder="Batas Usia Pensiun"
                        errorMessage="Masukkan Batas Usia Pensiun"
                        type="number"
                        className="form-control"
                        disabled={this.state.detailUuid != null ? true : false}
                        validate={{ required: { value: true } }}
                        value={this.state.detail.position_bup}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Grade <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <AvField
                        name="position_grade"
                        placeholder="grade"
                        errorMessage="Masukkan Grade"
                        type="number"
                        disabled={this.state.detailUuid != null ? true : false}
                        className="form-control"
                        validate={{ required: { value: true } }}
                        value={this.state.detail.position_grade}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Tanggal Berlaku <span className="text-danger">*</span>
                    </Label>
                    <Col md="8">
                      <DatePicker
                        name="position_start_date"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        errorMessage="Masukan Tanggal Berlaku"
                        validate={{ required: { value: true } }}
                        defaultValue={this.state.detail.position_start_date.substring(
                          0,
                          10
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Label className="col-md-4 col-form-label">
                      Tanggal Berakhir
                    </Label>
                    <Col md="8">
                      <DatePicker
                        name="position_end_date"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        errorMessage="Masukan Tanggal Berakhir"
                        validate={{ required: { value: false } }}
                        defaultValue={
                          this.state.detail.position_end_date != null
                            ? this.state.detail.position_end_date.substring(
                                0,
                                10
                              )
                            : ""
                        }
                      />
                    </Col>
                  </Row>
                </Fragment>
              )}
            </ModalBody>
            {this.state.updateUuid !== null && (
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit
                </Button>{" "}
                <Button onClick={() => this.toggleModal()}>Cancel</Button>
              </ModalFooter>
            )}
          </AvForm>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={
            this.state.updateUuid != null
              ? "Apakah anda yakin akan mengubah data ini?"
              : "Apakah anda yakin akan menghapus data ini?"
          }
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo={this.state.failedInfo} //"Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.show_is_digunakan && (
          <SweetAlert
            show={this.state.show}
            warning
            showCancel
            showConfirm={false}
            title="Peringatan"
            onCancel={() => this.hideAlert()}
          >
            Jabatan ini tidak dapat dihapus. Karena masih digunakan oleh:
            <br />
            <textarea
              name="postContent"
              className="form-control"
              disabled="disabled"
              rows={4}
              cols={40}
              defaultValue={this.state.list_digunakan}
            />
          </SweetAlert>
        )}
      </Fragment>
    );
  }
}

export default TableActiveComponent;
